import { Link } from "@reach/router";
import React from "react";
import simboloPrimary from "../../assets/rebrand/simbolo-primary.png";
import logotipoPrimary from "../../assets/rebrand/logotipo-primary.png";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm vw-100 align-items-center">
      <div className="container-fluid px-0 navbar-container d-flex flex-wrap align-items-center justify-content-between">
        <Link
          className="navbar-brand d-flex align-items-center py-2 ps-3 mb-0"
          to="/#landing"
        >
          <img
            src={simboloPrimary}
            alt="TheBodyMethod"
            className="logo-navbar d-block"
            style={{ height: "50px" }}
          />
          <img
            src={logotipoPrimary}
            alt="TheBodyMethod"
            style={{ marginLeft: "-8px" }}
            className="logo-navbar d-block"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse mw-100" id="navbarNav">
          <div className="container-fluid px-1 px-md-3 pe-md-5">
            <ul className="navbar-nav nav align-items-center justify-content-end">

              <li className="nav-item">
                <a className="nav-link" href="/#about">
                  Conócenos
                </a>
              </li>
              <li
                className={`nav-item ${window.location.href.includes("paquetes")
                  ? "nav-item-active"
                  : ""
                  }`}
              >
                <Link className="nav-link" to="/paquetes">
                  Paquetes
                </Link>
              </li>
              <li
                className={`nav-item ${window.location.href.includes("rewards")
                  ? "nav-item-active"
                  : ""
                  }`}
              >
                <Link className="nav-link" to="/rewards/">
                  Rewards
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://tbmcertifications.com/"
                  target="_blank"
                >
                  Certificaciones
                </a>
              </li>
              <li className="ms-md-3">
                <Link
                  className="btn btn-primary bold navbar-cta text-uppercase mt-0"
                  to="/entrar"
                >
                  <i className="fa fa-user"></i>{" "}
                  <span className="ms-1">Ingresar</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
